<template>
  <base-dialog @cancel="cancelDialog">
    <div slot="header">{{$t('bill.check_resource_policy')}}</div>
    <div slot="body">
      <div class="mb-2">{{$t('bill.cost_policy_check_tip')}}</div>
      <div>{{params.errorList.join(',')}}</div>
    </div>
    <div slot="footer">
      <a-button type="primary" @click="cancelDialog">{{ $t('dialog.ok') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'

export default {
  name: 'CostconversionPolicyErrorDialog',
  mixins: [DialogMixin, WindowsMixin],
  data () {
    return {
    }
  },
  methods: {
  },
}
</script>
